module.exports = __webpack_public_path__ + "img/Wp_2015.f63254d3.png";